var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "my-blocks" },
    [
      _c(
        "div",
        { staticClass: "blocks-list" },
        _vm._l(_vm.blocks, function (block) {
          return _c("div", { key: block._id, staticClass: "block-item" }, [
            _c("div", { staticClass: "block-info" }, [
              _c("span", { staticClass: "material-icons block-icon" }, [
                _vm._v(_vm._s(block.icon || "extension")),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "block-details" }, [
                _c("h3", [_vm._v(_vm._s(block.name))]),
                _vm._v(" "),
                _c("p", [_vm._v(_vm._s(block.description))]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "block-status" },
                  [
                    _c(
                      "a-tag",
                      {
                        attrs: {
                          color: _vm.getStatusColor(block.approvalStatus),
                        },
                      },
                      [
                        _vm._v(
                          "\n                            " +
                            _vm._s(_vm.getStatusText(block.approvalStatus)) +
                            "\n                        "
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    block.publishedVersion
                      ? _c("a-tag", { attrs: { color: "blue" } }, [
                          _vm._v(
                            "\n                            " +
                              _vm._s(
                                _vm.$t("chatbotv2.published") || "Published"
                              ) +
                              "\n                        "
                          ),
                        ])
                      : _c("a-tag", { attrs: { color: "orange" } }, [
                          _vm._v(
                            "\n                            " +
                              _vm._s(_vm.$t("chatbotv2.draft") || "Draft") +
                              "\n                        "
                          ),
                        ]),
                    _vm._v(" "),
                    _c(
                      "span",
                      { staticClass: "stats" },
                      [
                        _c("a-icon", { attrs: { type: "download" } }),
                        _vm._v(
                          " " +
                            _vm._s(block.usageCount || 0) +
                            "\n                            "
                        ),
                        _c("a-icon", {
                          staticStyle: { "margin-left": "12px" },
                          attrs: { type: "star" },
                        }),
                        _vm._v(
                          "\n                            " +
                            _vm._s(
                              block.averageRating
                                ? block.averageRating.toFixed(1)
                                : "0.0"
                            ) +
                            "\n                        "
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ]),
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "block-actions" },
              [
                _c(
                  "a-button",
                  {
                    attrs: { size: "small" },
                    on: {
                      click: function ($event) {
                        return _vm.editBlock(block._id)
                      },
                    },
                  },
                  [
                    _c("a-icon", { attrs: { type: "edit" } }),
                    _vm._v(
                      "\n                    " +
                        _vm._s(_vm.$t("message.edit") || "Edit") +
                        "\n                "
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                !block.publishedVersion
                  ? _c(
                      "a-button",
                      {
                        attrs: { size: "small", type: "primary" },
                        on: {
                          click: function ($event) {
                            return _vm.publishBlock(block._id)
                          },
                        },
                      },
                      [
                        _c("a-icon", { attrs: { type: "rocket" } }),
                        _vm._v(
                          "\n                    " +
                            _vm._s(_vm.$t("chatbotv2.publish") || "Publish") +
                            "\n                "
                        ),
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                block.visibility !== "unlisted" && block.publishedVersion
                  ? _c(
                      "a-button",
                      {
                        attrs: { size: "small" },
                        on: {
                          click: function ($event) {
                            return _vm.unlistBlock(block._id)
                          },
                        },
                      },
                      [
                        _c("a-icon", { attrs: { type: "eye-invisible" } }),
                        _vm._v(
                          "\n                    " +
                            _vm._s(_vm.$t("chatbotv2.unlist") || "Unlist") +
                            "\n                "
                        ),
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                !block.publishedVersion || (block.usageCount || 0) === 0
                  ? _c(
                      "a-popconfirm",
                      {
                        attrs: {
                          title:
                            _vm.$t("chatbotv2.confirmDeleteBlock") ||
                            "Are you sure you want to delete this block?",
                        },
                        on: {
                          confirm: function ($event) {
                            return _vm.deleteBlock(block._id)
                          },
                        },
                      },
                      [
                        _c(
                          "a-button",
                          { attrs: { size: "small", type: "danger" } },
                          [_c("a-icon", { attrs: { type: "delete" } })],
                          1
                        ),
                      ],
                      1
                    )
                  : block.publishedVersion && (block.usageCount || 0) > 0
                  ? _c(
                      "a-tooltip",
                      {
                        attrs: {
                          title:
                            _vm.$t("chatbotv2.cannotDeleteActiveBlock") ||
                            "Cannot delete block with active usage",
                        },
                      },
                      [
                        _c(
                          "a-button",
                          {
                            attrs: {
                              size: "small",
                              type: "danger",
                              disabled: "",
                            },
                          },
                          [_c("a-icon", { attrs: { type: "delete" } })],
                          1
                        ),
                      ],
                      1
                    )
                  : _vm._e(),
              ],
              1
            ),
          ])
        }),
        0
      ),
      _vm._v(" "),
      _vm.blocks.length === 0
        ? _c(
            "div",
            { staticClass: "empty-state" },
            [
              _c("a-empty", {
                attrs: {
                  description:
                    _vm.$t("chatbotv2.noBlocksCreated") ||
                    "No blocks created yet",
                },
              }),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.showChangelogModal
        ? _c(
            "Modal2",
            {
              attrs: {
                title: _vm.$t("chatbotv2.publishBlock") || "Publish Block",
                description:
                  _vm.$t("chatbotv2.enterChangelog") ||
                  "Enter changelog (optional)",
                okText: _vm.$t("chatbotv2.publish") || "Publish",
                cancelText: _vm.$t("message.cancel") || "Cancel",
              },
              on: {
                ok: _vm.confirmPublish,
                cancel: function ($event) {
                  _vm.showChangelogModal = false
                },
              },
            },
            [
              _c("a-textarea", {
                attrs: {
                  rows: 5,
                  placeholder:
                    _vm.$t("chatbotv2.changelogPlaceholder") ||
                    "Describe the changes made in this version...",
                },
                model: {
                  value: _vm.changelogInput,
                  callback: function ($$v) {
                    _vm.changelogInput = $$v
                  },
                  expression: "changelogInput",
                },
              }),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }